// All service-area location data. Naples is primary; secondary cities support.
export const LOCATIONS = [
    {
        slug: "naples",
        name: "Naples",
        is_primary: true,
        h1: "Pool Cage Repair & Screen Repair in Naples, FL",
        meta_title:
            "Pool Cage Repair Naples FL · Free Estimates · A1 Screening",
        meta_description:
            "Family-owned pool cage repair, rescreening, and lanai screen repair in Naples, FL. Free estimates. Serving Southwest Florida since 1999. Call 239-434-7306.",
        hero:
            "Naples is our home base. We've been repairing pool cages and screens here since 1999 — clean work, free estimates, and the kind of communication homeowners can actually count on.",
        neighborhoods: [
            "Pelican Bay",
            "Olde Naples",
            "Park Shore",
            "Lely",
            "Marco-area neighborhoods",
        ],
        common_problems: [
            "No-see-ums and mosquitoes getting through.",
            "Sun-faded, brittle screens.",
            "Storm damage from a tropical storm or hurricane.",
            "HOA appearance letters.",
            "Stuck or worn-out screen doors.",
        ],
        we_work_with: [
            {
                title: "Naples HOA homeowners",
                body: "Got an appearance letter? We've handled it before. We'll get the cage back to spec quickly and cleanly.",
            },
            {
                title: "Storm-damaged homes",
                body: "After a hurricane or tropical storm, we move down the list as fast as our schedule allows. Call early to get on it. Availability may vary by schedule and season.",
            },
            {
                title: "Seasonal residents and snowbirds",
                body: "Heading back north? We'll handle the repair while you're away and send photos when it's done — so your pool cage is ready the day you fly back to Naples.",
            },
            {
                title: "Property managers and landlords",
                body: "We coordinate directly with tenants and send clear photo updates so your Naples rental stays guest-ready.",
            },
        ],
        faqs: [
            {
                q: "Who fixes pool screens in Naples?",
                a: "A1 Screening repairs pool screens in Naples and across Southwest Florida. Family-owned since 1999. Call 239-434-7306 or request a free estimate online.",
            },
            {
                q: "Who repairs lanais in Naples?",
                a: "We do — lanai panels, frames, screen doors, and full lanai rescreens across all Naples neighborhoods.",
            },
            {
                q: "Can A1 Screening repair storm-damaged screens in Naples?",
                a: "Yes — most storm-damaged pool cages and screens in Naples can be repaired or rescreened. Storm repair availability may vary by schedule and season.",
            },
            {
                q: "Do Naples homeowners need full rescreening or panel repair?",
                a: "It depends. One or two torn panels = usually a spot repair. Brittle, faded, or torn-in-multiple-places = usually a full rescreen. We'll give you both options in your free estimate.",
            },
            {
                q: "How do I request a pool cage repair estimate in Naples?",
                a: "Call 239-434-7306, fill out the short estimate form, or upload a few photos for technician review. Estimates are free.",
            },
        ],
    },
    {
        slug: "fort-myers",
        name: "Fort Myers",
        is_primary: false,
        h1: "Pool Cage Repair in Fort Myers, FL",
        meta_title: "Pool Cage Repair Fort Myers · Screen Repair · A1 Screening",
        meta_description:
            "Pool cage repair, rescreening, and lanai screen repair in Fort Myers, FL. Free estimates. Family-owned. Serving Southwest Florida since 1999.",
        hero:
            "We serve Fort Myers from our Naples base. Pool cage repair, rescreens, lanais, and storm damage — clean, free estimates and reliable communication.",
        unique_local:
            "We serve Fort Myers from our Naples base — the same crew and the same free written estimates we give every Naples customer. Pool cages, lanais, and screen doors across the Fort Myers area.",
        local_points: [
            "Full pool cage rescreens and single-panel repairs",
            "Lanai and screen door work handled on the same visit when possible",
            "Send photos before we drive out — we'll arrive prepared for your project",
        ],
        relevant_services: ["pool-cage-repair", "pool-rescreening", "lanai-screen-repair", "screen-door-repair"],
        faqs: [
            {
                q: "Do you serve Fort Myers?",
                a: "Yes — we serve Fort Myers from our Naples base.",
            },
            {
                q: "How fast can you get to a Fort Myers job?",
                a: "We schedule based on availability. Free estimate first; we'll give you a clear timeline.",
            },
            {
                q: "Can I send photos for a Fort Myers estimate?",
                a: "Yes — photos almost always speed things up.",
            },
        ],
    },
    {
        slug: "cape-coral",
        name: "Cape Coral",
        is_primary: false,
        h1: "Pool Cage Repair in Cape Coral, FL",
        meta_title:
            "Pool Cage Repair Cape Coral · Screen Repair · A1 Screening",
        meta_description:
            "Cape Coral pool cage repair and rescreening. Free estimates. Family-owned and serving Southwest Florida since 1999. Call 239-434-7306.",
        hero:
            "Cape Coral pool cage repair, rescreens, and lanai work — same Naples-based team since 1999.",
        unique_local:
            "Cape Coral cage styles vary widely — older builds, newer enclosures, and everything between. We bring the right mesh and hardware for each, and check the frame while we're at it.",
        local_points: [
            "Repairs and full rescreens on all common Cape Coral cage styles",
            "Bent or corroded frame sections checked during your free estimate",
            "Waterfront sun and wind exposure factored into screen recommendations",
        ],
        relevant_services: ["pool-cage-repair", "pool-rescreening", "structural-pool-cage-repair", "lanai-screen-repair"],
        faqs: [
            {
                q: "Do you serve Cape Coral?",
                a: "Yes — we serve Cape Coral.",
            },
            {
                q: "Do you handle full pool cage rescreens in Cape Coral?",
                a: "Yes — full-cage rescreens are part of our regular work.",
            },
            {
                q: "Can you give a photo estimate for Cape Coral?",
                a: "Yes — send photos and we'll get you moving sooner.",
            },
        ],
    },
    {
        slug: "lehigh-acres",
        name: "Lehigh Acres",
        is_primary: false,
        h1: "Screen Repair & Pool Cage Repair in Lehigh Acres, FL",
        meta_title: "Screen Repair Lehigh Acres FL · A1 Screening",
        meta_description:
            "Pool cage, lanai, and screen door repair in Lehigh Acres. Free estimates. Family-owned. Serving Southwest Florida since 1999.",
        hero:
            "Screen repair and pool cage work in Lehigh Acres — Naples-based, family-owned, free estimates.",
        unique_local:
            "We get to Lehigh Acres regularly from our Naples base. Scheduling depends on our route and the weather — and we'll always give you a clear timeline with your free estimate.",
        local_points: [
            "Screen doors and lanai panels — often finished in a single visit",
            "Pool cage panel repairs and full rescreens",
            "Clear scheduling — we tell you when we can come, and we show up",
        ],
        relevant_services: ["screen-door-repair", "lanai-screen-repair", "pool-cage-repair"],
        faqs: [
            { q: "Do you serve Lehigh Acres?", a: "Yes — we serve Lehigh Acres." },
            {
                q: "Can you fix screen doors in Lehigh Acres?",
                a: "Yes — sliding and swing doors. Single-visit when possible.",
            },
        ],
    },
    {
        slug: "bonita-springs",
        name: "Bonita Springs",
        is_primary: false,
        h1: "Pool Cage Repair in Bonita Springs, FL",
        meta_title:
            "Pool Cage Repair Bonita Springs · Screen Repair · A1 Screening",
        meta_description:
            "Bonita Springs pool cage repair, rescreening, and lanai screen repair. Free estimates. Family-owned and Naples-based. Since 1999.",
        hero:
            "Bonita Springs is just up the road from our Naples base. Pool cages, lanais, screen doors — clean work and free estimates.",
        unique_local:
            "Bonita Springs is just up the road from our Naples base — we're often in the area the same week we're working in Naples. Pool cages, lanais, and screen doors, all with free written estimates.",
        local_points: [
            "Pool cage panel repairs and full rescreens",
            "Coastal sun and salt-air wear on mesh and fasteners checked during estimates",
            "Storm-season repairs — availability may vary by schedule and season",
        ],
        relevant_services: ["pool-cage-repair", "pool-rescreening", "lanai-screen-repair", "storm-screen-repair"],
        faqs: [
            { q: "Do you serve Bonita Springs?", a: "Yes — we serve Bonita Springs." },
            {
                q: "Are you close enough to come quickly?",
                a: "Yes — Bonita Springs is Naples-adjacent. We schedule based on availability and give clear timelines.",
            },
            {
                q: "Do you do storm repair in Bonita Springs?",
                a: "Yes — storm repair availability may vary by schedule and season. Call to get on the list.",
            },
        ],
    },
];

export const LOCATION_BY_SLUG = LOCATIONS.reduce((acc, l) => {
    acc[l.slug] = l;
    return acc;
}, {});
